import { useState, useEffect } from "react";
import adminApi from "../api/adminAxios";

export default function ManageUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [selectedUser, setSelectedUser] = useState(null);
  const [confirmUser, setConfirmUser] = useState(null);

  useEffect(() => {
    adminApi.get("admin/users/")
      .then(r => setUsers(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = users.filter(u => {
    const matchSearch = !search || [u.username, u.email, String(u.id)].some(v => v?.toLowerCase().includes(search.toLowerCase()));
    const matchFilter = filter === "all" || (filter === "active" && u.is_active) || (filter === "inactive" && !u.is_active) || (filter === "new" && new Date(u.date_joined) > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
    return matchSearch && matchFilter;
  });

  const handleToggleActive = async (user) => {
    try {
      await adminApi.patch(`admin/users/${user.id}/`, { is_active: !user.is_active });
      setUsers(prev => prev.map(u => u.id === user.id ? { ...u, is_active: !u.is_active } : u));
      if (selectedUser?.id === user.id) setSelectedUser(prev => ({ ...prev, is_active: !prev.is_active }));
    } catch {}
  };

  const initials = name => name?.slice(0, 2).toUpperCase() || "??";
  const avatarColor = name => {
    const colors = ["#e07b39","#3a8a68","#3a6ab0","#8a3a8a","#c47a3a"];
    return colors[(name?.charCodeAt(0) || 0) % colors.length];
  };

  return (
    <div style={{ padding: "32px 36px", fontFamily: "Georgia, serif" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "28px" }}>
        <div>
          <h1 style={{ fontFamily: "Georgia, serif", fontSize: "24px", fontWeight: "700", color: "#1a1a1a" }}>Manage Users</h1>
          <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#aaa", marginTop: "4px" }}>View and manage your registered customer database.</p>
        </div>
      </div>

      {/* Search + filters */}
      <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", border: "1px solid #f0ebe3", marginBottom: "20px" }}>
        <div style={{ display: "flex", gap: "14px", alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ position: "relative", flex: 1, minWidth: "200px" }}>
            <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#bbb" }}>🔍</span>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name, email, or user ID..."
              style={{ width: "100%", padding: "9px 12px 9px 34px", borderRadius: "9px", border: "1.5px solid #e8d5b8", background: "#fffaf4", fontFamily: "Georgia, serif", fontSize: "12px", outline: "none", boxSizing: "border-box" }} />
          </div>
          <div style={{ display: "flex", gap: "6px" }}>
            {["all", "active", "inactive", "new"].map(f => (
              <button key={f} onClick={() => setFilter(f)}
                style={{ padding: "7px 16px", borderRadius: "999px", border: "none", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: filter === f ? "700" : "400", background: filter === f ? "#e07b39" : "#f0ebe3", color: filter === f ? "#fff" : "#888" }}>
                {f === "all" ? "All Users" : f === "active" ? "Active" : f === "inactive" ? "Inactive" : "New Users"}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Table */}
      <div style={{ background: "#fff", borderRadius: "14px", border: "1px solid #f0ebe3", overflow: "hidden" }}>
        <div style={{ display: "grid", gridTemplateColumns: "90px 1fr 1fr 120px 1fr 100px 80px", gap: "8px", padding: "12px 20px", background: "#f7f2eb" }}>
          {["USER ID", "USERNAME", "EMAIL ID", "CONTACT", "ADDRESS", "DATE JOINED", "ACTIONS"].map(h => (
            <span key={h} style={{ fontFamily: "Georgia, serif", fontSize: "9px", fontWeight: "700", color: "#aaa", letterSpacing: "0.08em" }}>{h}</span>
          ))}
        </div>

        {loading ? (
          <p style={{ padding: "32px", color: "#aaa", fontFamily: "Georgia, serif", fontSize: "13px" }}>Loading users...</p>
        ) : filtered.length === 0 ? (
          <p style={{ padding: "32px", color: "#aaa", fontFamily: "Georgia, serif", fontSize: "13px", textAlign: "center" }}>No users found.</p>
        ) : (
          filtered.map(user => (
            <div key={user.id} style={{ display: "grid", gridTemplateColumns: "90px 1fr 1fr 120px 1fr 100px 80px", gap: "8px", padding: "14px 20px", borderBottom: "1px solid #f7f2eb", alignItems: "center" }}>
              <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", fontWeight: "700", color: "#e07b39" }}>#{user.id}</span>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: avatarColor(user.username), display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontFamily: "Georgia, serif", fontSize: "10px", fontWeight: "700", flexShrink: 0 }}>
                  {initials(user.username)}
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span style={{ fontFamily: "Georgia, serif", fontSize: "12px", fontWeight: "600", color: user.is_active ? "#1a1a1a" : "#aaa" }}>{user.username}</span>
                  {!user.is_active && <span style={{ fontFamily: "Georgia, serif", fontSize: "9px", color: "#c0392b", fontWeight: "700", letterSpacing: "0.06em" }}>INACTIVE</span>}
                </div>
              </div>
              <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#555", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.email}</span>
              <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#555" }}>{user.contact_number || "—"}</span>
              <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#555", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.address || "—"}</span>
              <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#aaa" }}>
                {new Date(user.date_joined).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
              </span>
              <div style={{ display: "flex", gap: "6px" }}>
                <button onClick={() => setSelectedUser(user)} title="View"
                  style={{ background: "#f0ebe3", border: "none", borderRadius: "6px", padding: "5px 8px", cursor: "pointer", fontSize: "12px" }}>👁️</button>
                <button
                  onClick={() => user.is_active ? setConfirmUser(user) : handleToggleActive(user)}
                  title={user.is_active ? "Deactivate" : "Activate"}
                  style={{ background: user.is_active ? "#fff0f0" : "#eefaf4", border: "none", borderRadius: "6px", padding: "5px 8px", cursor: "pointer", fontSize: "12px" }}>
                  {user.is_active ? "🚫" : "✅"}
                </button>
              </div>
            </div>
          ))
        )}
        {!loading && (
          <div style={{ padding: "12px 20px", background: "#faf7f2" }}>
            <span style={{ fontFamily: "Georgia, serif", fontSize: "11px", color: "#aaa" }}>Showing {filtered.length} of {users.length} users</span>
          </div>
        )}
      </div>

      {/* User detail modal */}
      {selectedUser && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}
          onClick={e => { if (e.target === e.currentTarget) setSelectedUser(null); }}>
          <div style={{ background: "#fff", borderRadius: "18px", padding: "28px", maxWidth: "480px", width: "100%", boxShadow: "0 16px 60px rgba(0,0,0,.15)" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h3 style={{ fontFamily: "Georgia, serif", fontSize: "16px", fontWeight: "700", color: "#1a1a1a" }}>User Details</h3>
              <button onClick={() => setSelectedUser(null)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: "18px", color: "#aaa" }}>✕</button>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "20px" }}>
              <div style={{ width: "52px", height: "52px", borderRadius: "50%", background: avatarColor(selectedUser.username), display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontFamily: "Georgia, serif", fontSize: "18px", fontWeight: "700" }}>
                {initials(selectedUser.username)}
              </div>
              <div>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "15px", fontWeight: "700", color: "#1a1a1a" }}>{selectedUser.username}</p>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "12px", color: "#aaa" }}>{selectedUser.role}</p>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
              {[
                { label: "Email", value: selectedUser.email },
                { label: "Contact", value: selectedUser.contact_number || "—" },
                { label: "Role", value: selectedUser.role },
                { label: "Status", value: selectedUser.is_active ? "✅ Active" : "🚫 Inactive" },
                { label: "Orders", value: selectedUser.order_count || 0 },
                { label: "Joined", value: new Date(selectedUser.date_joined).toLocaleDateString("en-IN") },
              ].map(({ label, value }) => (
                <div key={label} style={{ background: "#faf7f2", borderRadius: "10px", padding: "12px" }}>
                  <p style={{ fontFamily: "Georgia, serif", fontSize: "9px", color: "#aaa", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: "4px" }}>{label}</p>
                  <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "600", color: "#1a1a1a" }}>{value}</p>
                </div>
              ))}
            </div>
            {selectedUser.address && (
              <div style={{ background: "#faf7f2", borderRadius: "10px", padding: "12px", marginTop: "14px" }}>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "9px", color: "#aaa", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: "4px" }}>Address</p>
                <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#1a1a1a" }}>{selectedUser.address}</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Deactivate confirmation modal */}
      {confirmUser && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}
          onClick={e => { if (e.target === e.currentTarget) setConfirmUser(null); }}>
          <div style={{ background: "#fff", borderRadius: "18px", padding: "32px", maxWidth: "400px", width: "100%", boxShadow: "0 16px 60px rgba(0,0,0,.2)", textAlign: "center" }}>
            <div style={{ fontSize: "48px", marginBottom: "16px" }}>🚫</div>
            <h3 style={{ fontFamily: "Georgia, serif", fontSize: "18px", fontWeight: "700", color: "#1a1a1a", marginBottom: "10px" }}>
              Deactivate User?
            </h3>
            <p style={{ fontFamily: "Georgia, serif", fontSize: "13px", color: "#888", lineHeight: "1.7", marginBottom: "24px" }}>
              <strong style={{ color: "#1a1a1a" }}>{confirmUser.username}</strong> will lose access to their account immediately. Their data and order history will be preserved in Archives.
            </p>
            <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
              <button onClick={() => setConfirmUser(null)}
                style={{ padding: "10px 24px", borderRadius: "10px", border: "1.5px solid #f0ebe3", background: "#fff", color: "#888", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "600" }}>
                Cancel
              </button>
              <button onClick={() => { handleToggleActive(confirmUser); setConfirmUser(null); }}
                style={{ padding: "10px 24px", borderRadius: "10px", border: "none", background: "#c0392b", color: "#fff", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: "700" }}>
                Yes, Deactivate
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}